/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { AIContextServicePanelResourceResponse } from './ContextPanelServiceTypes.tsx';
import { getContextPanelSuggestions } from './graphqlContextPanelQuery.tsx';

export const getServiceSuggestionData = (
	issueId: string,
	cloudId: string,
): Promise<AIContextServicePanelResourceResponse> => {
	return getContextPanelSuggestions(cloudId, issueId);
};
